module.exports = __webpack_public_path__ + "img/glogo227.44da5065.png";